import {meetingApiClient} from "../MeetingApiClient";
import {MeetingParticipant, MeetingStatus} from "../Meeting";
import {msalUtils} from "../../../MsalUtils";
import {isRelayContainerNotFoundError} from "../Relay/utils/relayUtils";
import {setActiveMeeting, setParticipatingInMeeting, setShowMeetingControls} from "../meetingSlice";
import {useAppDispatch} from "../../../store/hooks";
import {useRelayContext} from "../Relay/types/RelayContext";
import {useMsal} from "@azure/msal-react";
import {useHistory} from "react-router-dom";


type JoinMeetingOptions = {
    meetingId: string;
    profileId: string;
    onClickEndedMeeting: () => void;
};

type MeetingConnectionUtils = {
    joinMeeting: (options: JoinMeetingOptions) => Promise<void>;};

const JoinMeetingUtils = (): MeetingConnectionUtils => {

    const msal = useMsal();
    const dispatch = useAppDispatch();
    const history = useHistory();

    const relayContext = useRelayContext();


    const joinMeeting = ({
                             meetingId,
                             profileId,
                             onClickEndedMeeting
                         }: JoinMeetingOptions): Promise<void> => {

        const lanId = msalUtils.getLanId(msal);
        const userName = msalUtils.getAccountName(msal);
        return meetingApiClient.getMeeting(profileId, meetingId)
            .then((activeMeeting)=> {
                if (activeMeeting.status === MeetingStatus.ENDED) {
                    onClickEndedMeeting();
                    return;
                }
                dispatch(setActiveMeeting(activeMeeting));

                const meetingParticipant: MeetingParticipant = {
                    meetingId: activeMeeting.onlineMeetingId,
                    userId: lanId,
                    userName: userName,
                    communicationsId: null
                };
                return  meetingApiClient.addParticipant(activeMeeting.profileIdToPresent, meetingParticipant).then(() =>
                    relayContext.connectToMeetingContainer(lanId, userName, activeMeeting.relayContainerId!).catch((connectError) => {
                        if (!isRelayContainerNotFoundError(connectError)) {
                            console.error('Failed to connect to meeting container', connectError);
                            throw connectError;
                        }
                        return  relayContext.createMeetingContainer(lanId, userName)
                            .then(( {containerId, documentId}) => {
                                return  meetingApiClient.updateMeeting({
                                    ...activeMeeting,
                                    relayContainerId: containerId,
                                    fluidRelayDocumentId: documentId
                                }).then((updatedMeeting) => {
                                    dispatch(setActiveMeeting(updatedMeeting));
                                }).catch(error => {
                                    console.error('Could not update meeting', error.message)
                                    throw error;
                                });
                            })
                            .catch ((reCreateError) => {
                                console.error('Failed to re-create the meeting container', reCreateError);
                                throw reCreateError
                            });
                    })
                ).then(() => {
                    dispatch(setShowMeetingControls(true));
                    history.push(`/Profile/${activeMeeting.profileIdToPresent}/ClientProfile/FamilyTree`);
                    dispatch(setParticipatingInMeeting(true));
                }).catch ((error) =>{
                    console.error('Could not fetch meeting', error.message);
                });
            });

    };

    return {
        joinMeeting,
    };

}

export default JoinMeetingUtils;